import React from 'react';
import styled from 'styled-components';
import { SRLWrapper } from 'simple-react-lightbox';

/** Styles */
const ImageRow = styled.div`text-align: center;`;
const ImageRowHeader = styled.h2`
	margin-top: 4rem;
	margin-bottom: 1rem;
`;
const ImageBorder = styled.div`
	border: solid 4px transparent;
	display: inline-block;
`;
const ServiceList = styled.ul`
	font-size: 1.5rem;
	margin-top: 0;
	margin-bottom: 4rem;
	line-height: 1.5; 
	fontWeight: '600;
`;
const Service = styled.li`
	margin: 3rem;
	line-height: 1.5;
`;
/** End Styles */

const options = {
	settings: {
		autoplaySpeed: 0,
		disableKeyboardControls: false,
		disablePanzoom: false,
		disableWheelControls: false,
		hideControlsAfter: 3000,
		lightboxTransitionSpeed: 0.6,
		lightboxTransitionTimingFunction: 'linear',
		overlayColor: 'rgba(0, 0, 0, 0.9)',
		slideAnimationType: 'slide',
		slideSpringValues: [ 300, 200 ],
		slideTransitionSpeed: 0.6,
		slideTransitionTimingFunction: 'linear'
	},
	buttons: {
		showAutoplayButton: false,
		showDownloadButton: false,
		showThumbnailsButton: false,
	},
	thumbnails: {
		showThumbnails: false
	}
};

const Services = () => (
	<div style={{ display: 'flex' }}>
		<section className="services">
			<p>
				<strong>Services we provide:</strong>
			</p>
			<ServiceList>
				<Service>We design complete sets of plans needed to pass state and regional approval.</Service>
				<Service>
					We provide a Title 24 Energy Report for all our plans. We can also provide this service for plans
					from other designers.
				</Service>
				<Service>
					Although not required for permits in most cases, we can provide 2D and 3D renders and conceptual
					drawings.
				</Service>
			</ServiceList>
			<SRLWrapper options={options}>
				<ImageRow>
					<ImageRowHeader>New Construction Samples</ImageRowHeader>

					{/* //TODO look at the syntax for the react lightbox I installed */}
					<ImageBorder>
						<a href={require('../images/newconstruction.jpg')} data-attribute="SRL" rel="lightbox[New]">
							<img src={require('../images/newconstructionthumb.jpg')} alt="New Construction Example" />
						</a>
					</ImageBorder>

					<ImageBorder>
						<a href={require('../images/erickson1.jpg')} data-attribute="SRL" rel="lightbox[New]">
							<img src={require('../images/erickson1thumb.jpg')} alt="Erickson First  Example" />
						</a>
					</ImageBorder>

					<ImageBorder>
						<a href={require('../images/erickson2.jpg')} data-attribute="SRL" rel="lightbox[New]">
							<img src={require('../images/erickson2thumb.jpg')} alt="Erickson Second Example" />
						</a>
					</ImageBorder>

					<ImageBorder>
						<a href={require('../images/coolhouseranch.jpg')} data-attribute="SRL" rel="lightbox[New]">
							<img src={require('../images/coolhouseranchthumb.jpg')} alt="Cool Ranch House Example" />
						</a>
					</ImageBorder>
				</ImageRow>
				<ImageRow>
					<ImageRowHeader>Addition Samples</ImageRowHeader>
					<ImageBorder>
						<a href={require('../images/residential1.jpg')} data-attribute="SRL" rel="lightbox[Additions]">
							<img src={require('../images/residential1thumb.jpg')} alt="Residential Example" />
						</a>
					</ImageBorder>
					<ImageBorder>
						<a href={require('../images/granner1.jpg')} data-attribute="SRL" rel="lightbox[Additions]">
							<img src={require('../images/granner1thumb.jpg')} alt="Granner  Example" />
						</a>
					</ImageBorder>
				</ImageRow>

				<ImageRow>
					<ImageRowHeader>Commercial Improvement Samples</ImageRowHeader>
					<a href={require('../images/commercial.jpg')} data-attribute="SRL" rel="lightbox[Commercial]">
						<img src={require('../images/commercialthumb.jpg')} alt="Commercial Example" />
					</a>
				</ImageRow>

				<ImageRow>
					<ImageRowHeader>2D Rendering Samples</ImageRowHeader>
					<a href={require('../images/2d_example.jpg')} data-attribute="SRL" rel="lightbox[2drenders]">
						<img src={require('../images/2d_examplethumb.jpg')} alt="Two Dimensional Example" />
					</a>
				</ImageRow>
			</SRLWrapper>
		</section>
	</div>
);

export default Services;
